<div id="layer-overlay-origin" class="container">
    <ng-container *ngIf="caseName$ | async as caseName">
        <div class="section title">
            <div class="case-name">{{ caseName }}</div>
        </div>
    </ng-container>
    <ng-container *ngrxLet="isSharedCase$ as isSharedCase">
        <div class="section new-job">
            <div class="button-row">
                <cds-button
                    size="sm"
                    action="outline"
                    [disabled]="isSharedCase"
                    (click)="showJobSelection($event)"
                >
                    New job
                </cds-button>
                <cds-button
                    size="sm"
                    action="outline"
                    [disabled]="isSharedCase"
                    (click)="createDatasetSharingLink()"
                >
                    Share
                </cds-button>
            </div>
            <cds-form-group>
                <div class="number-input-row">
                    <cds-icon shape="search"></cds-icon>
                    <input
                        class="number-input-no-arrow string-input-no-arrow"
                        type="text"
                        placeholder="Search"
                        [(ngModel)]="searchKey"
                        (keyup)="updateSearchKey($event)"
                    />
                </div>
            </cds-form-group>
        </div>
    </ng-container>
    <div class="scroll">
        <div>
            <app-viewer-layers></app-viewer-layers>
        </div>
    </div>
</div>
